//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { API } from 'aws-amplify'
import getOrderedMentors from '~/gql/getOrderedMentors.js'

export default {
  inheritAttrs: false,

  props: {
    title: {
      type: String,
      default: '',
    },
    link: {
      type: Object,
      default() {},
    },
    button: {
      type: Object,
      default() {},
    },
    type: {
      type: String,
      default: 'PageMentorsBreaker',
    },
  },
  data() {
    return { 
      items: [],
      illustrations: [
        
        {
          number: 1,
          src: require(`~/assets/img/element-hear-05.svg?data`),
          width: 274,
          height: 184,
          alt: '',
        },
        {
          number: 2,
          src: require(`~/assets/img/element-connect-07.svg?data`),
          width: 143,
          height: 113,
          alt: '',
        },
        {
          number: 3,
          src: require(`~/assets/img/element-learn-06.svg?data`),
          width: 222,
          height: 457,
          alt: '',
        },
      ],
    }
  },
  async fetch() {
    const { mentorsOrdereds } = await this.$graphcms.request(
      getOrderedMentors,
      {
        locale: [this.$i18n.locale],
        lang: [this.$i18n.locale],
        target: 'banner',
        limit: 4,
      }
    )

    if (mentorsOrdereds[0]?.mentors) {
      const items = mentorsOrdereds[0].mentors

      const { data } = await API.get('api', '/mentor/getAll')
      items.forEach((gcmsMentor) => {
        this.items.push({
          ...data.filter(
            (dbMentor) => dbMentor.graphcmsId === gcmsMentor.id
          )[0],
          ...gcmsMentor,
        })
      })
    }
  },
}
